import * as Api from "@api";
import { State } from "../";
import { ActionType } from "../types";
import { ThunkAction } from "redux-thunk";
import { LandingZoneRole, LandingZoneRolesAction } from "../types";

function getLandingZoneRolesRequest(): LandingZoneRolesAction {
  return {
    type: ActionType.GET_LANDING_ZONE_ROLES_REQUEST,
  };
}

function getLandingZoneRolesSuccess(
  landingZoneRoles: LandingZoneRole[]
): LandingZoneRolesAction {
  return {
    type: ActionType.GET_LANDING_ZONE_ROLES_SUCCESS,
    landingZoneRoles,
  };
}

function getLandingZoneRolesFailure(error: any): LandingZoneRolesAction {
  return {
    type: ActionType.GET_LANDING_ZONE_ROLES_FAILURE,
    error,
  };
}

export function getLandingZoneRoles(): ThunkAction<
  void,
  State,
  unknown,
  LandingZoneRolesAction
> {
  return async (dispatch, getState) => {
    const { network } = getState();

    if (!network.fetching.landingZoneRoles) {
      dispatch(getLandingZoneRolesRequest());
      try {
        const landingZoneRoles = await Api.getActiveLandingZoneRoles();

        dispatch(getLandingZoneRolesSuccess(landingZoneRoles));
      } catch (error) {
        dispatch(getLandingZoneRolesFailure(error));
      }
    }
  };
}
